<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <div class="flex flex-col gap-4">
      <app-form-card title="Driver Instructions" icon="Package">
        <app-form-field>
          <app-textarea
            formControlName="driverInstructions"
            placeholder="e.g., Driver must accept tracking. Call 1hr before arrival."
            [rows]="4"
          ></app-textarea>
        </app-form-field>
      </app-form-card>
      <app-form-card title="Internal load notes" icon="Package">
        <app-form-field>
          <app-textarea
            formControlName="notes"
            placeholder="e.g., Driver must accept tracking. Call 1hr before arrival."
            [rows]="4"
          ></app-textarea>
        </app-form-field>
      </app-form-card>
    </div>
  </div>
  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Saving..." : "Save Changes" }}
    </app-button>
  </div>
</div>
